module.exports = __webpack_public_path__ + "assets/img/notice.9092d6bd.png";